import { useDataFormat } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let locations = useDataFormat({
    context: 'payment_account',
    path: 'payer_person.patient.tx_cards',
    viewPath: props.viewPath,
    format: treatment_cards =>
      Object.values(
        treatment_cards
          .map(treatment_card => treatment_card.txs[0].organization)
          .reduce(
            (acc, organization) => ({
              ...acc,
              [organization.id]: organization,
            }),
            {}
          )
      ),
  })
  return locations
}
